import { Button, Form, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { useEffect, useState } from 'react';
import DropFiles from '../content/DropFiles';
import { useUploadContentMutation } from 'utils/rest/content/uploadContent';
import { filesBase64 } from 'utils/files/filesToBase64';
import { useSelector } from 'react-redux';
import { useGetContentMutation } from 'utils/rest/content/getContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { testNewsFormat } from 'utils/files/testFilesFormat';

const NewsForm = ({
  typeCategory,
  close,
  prev,
  imgs,
  form,
  uri,
  setImagesUri
}) => {
  const [imagesHover, setImagesHover] = useState(false);
  const [images, setImages] = useState(imgs ?? []);
  const [dragging, setDragging] = useState(false);

  const { user } = useSelector(state => state.auth);

  const [formData, setFormData] = useState(
    form ?? {
      category01ISbb_q4sg_content_categories2ID: typeCategory.category
    }
  );
  console.log(formData);
  const { mutate: uploadContent, isPending } = useUploadContentMutation();
  const { mutate: getContent } = useGetContentMutation();

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleBack = () => {
    if (prev) prev();
    close();
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const dataImg = await filesBase64(formData, images, 'img');

    if (dataImg) {
      uploadContent(dataImg, {
        onSuccess: () => {
          close();
          getContent(user?._id);
        }
      });
    }
  };

  const handleDrop = async e => {
    e.preventDefault();
    setDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);

    const validated = await testNewsFormat(images, droppedFiles);
    setImages(validated);
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    if (type === 'img') {
      setDragging({ images: true, documents: false });
    } else {
      setDragging({ images: false, documents: true });
    }
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  useEffect(() => {
    if (formData.contentISplaintextbox) {
      setFormData({ ...formData, urlISplaintextbox: `/news` });
    }
  }, [formData.contentISplaintextbox]);

  return (
    <Form onSubmit={handleSubmit} className="px-6 pt-4">
      <Row>
        <fieldset className={'form-legend-item-wrapper mb-4'}>
          <legend className="item-title fs-1 fw-semi-bold">
            News Headline
          </legend>
          <Form.Control
            value={formData.name}
            name="name"
            onChange={handleChange}
            required
          />
        </fieldset>
      </Row>
      <Row>
        <fieldset className={'form-legend-item-wrapper mb-4'}>
          <legend className="item-title fs-1 fw-semi-bold">
            News Article Text
          </legend>
          <Form.Control
            as="textarea"
            rows={3}
            value={formData.contentISplaintextbox}
            name="contentISplaintextbox"
            onChange={handleChange}
            required
          />
        </fieldset>
      </Row>
      <Row>
        <fieldset
          className="form-legend-item-wrapper mb-4 position-relative"
          style={{ zIndex: 50 }}
        >
          <legend className="item-title fs-1 d-flex align-items-center">
            <span className="cursor-pointer fw-semi-bold">Image</span>
            <div
              className="mx-2 info-block position-relative"
              onMouseEnter={() => setImagesHover(true)}
              onMouseLeave={() => setImagesHover(false)}
            >
              <FontAwesomeIcon icon={faQuestion} size="xs" />
              {imagesHover && (
                <div className="position-absolute position-info">
                  <ul className="m-0">
                    <li>
                      Only <strong>image</strong> files are allowed.
                    </li>
                    <li>
                      Accepted image formats: <strong>.png</strong> and{' '}
                      <strong>.jpg</strong>.
                    </li>
                    <li>
                      You can upload only <strong>1 image</strong> maximum.
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </legend>
          <label
            style={{
              minHeight: '120px',
              maxHeight: '120px',
              width: '100%'
            }}
            onDragOver={e => handleDragOver(e, 'img')}
            onDragLeave={() => handleDragLeave('img')}
            onDrop={e => handleDrop(e, 'img')}
          >
            <DropFiles
              dragging={dragging}
              items={images}
              setFiles={setImages}
              form={formData}
              setForm={setFormData}
              type={'news'}
              uri={uri}
              setImagesUri={setImagesUri}
            />
          </label>
        </fieldset>
      </Row>
      <Flex className="gap-5">
        <Button variant="primary" type="submit" disabled={isPending}>
          Submit For Approval
        </Button>
        {prev && (
          <Button
            variant="primary"
            type="button"
            onClick={handleBack}
            disabled={isPending}
          >
            Back
          </Button>
        )}
      </Flex>
    </Form>
  );
};

export default NewsForm;
